export const MERCARI_BENEFIT = {
  iconUrl: 'mercari-static',
  title: '메루카리 해외구매',
  contents: ['일본 현지 세컨핸드를 국내 상품처럼 간편하게 구매'],
};
